var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSadFace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 149,
    viewBox: "0 0 200 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10326_157061)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M2.15332 71.6787C5.31145 83.8839 11.9913 94.4347 22.5475 99.5491C44.4926 110.178 93.9844 104.696 130.922 98.4037C150.029 95.1492 166.823 86.1675 179.023 73.5278L2.15332 71.6787Z",
    fill: "#4211A0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M195.851 14.2269H175.584C174.622 14.2269 173.833 13.5142 173.833 12.6433C173.833 11.7724 174.622 11.0578 175.584 11.0578H179.089C178.125 11.0578 177.338 10.3451 177.338 9.47241C177.338 8.5997 178.125 7.8888 179.089 7.8888H176.587C175.624 7.8888 174.835 7.17609 174.835 6.30337C174.835 5.43066 175.624 4.71977 176.587 4.71977H187.165C184.818 3.73251 182.075 3.03071 178.913 2.66162C150.068 -0.689226 139.77 1.5271 136.137 3.80524C131.609 6.68018 126.58 8.67503 121.312 9.68513C103.516 13.0069 70.2347 17.0032 40.0698 8.41243C25.0774 4.13432 13.9339 11.3542 7.25586 23.4231H199.371C199.12 19.9159 198.369 16.6759 196.991 13.8414C196.664 14.0934 196.263 14.2291 195.851 14.2269Z",
    fill: "#4211A0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M0.434206 46.2026C-0.344242 53.301 -0.0796242 60.4751 1.21965 67.4968L179.158 73.3858C184.056 68.3056 188.218 62.5638 191.522 56.3279L0.434206 46.2026ZM70.8111 61.3933H67.3075C68.2712 61.3933 69.0602 62.1078 69.0602 62.9787C69.0602 63.8496 68.2712 64.5623 67.3075 64.5623H47.0406C46.0788 64.5623 45.2898 63.8496 45.2898 62.9787C45.2898 62.1078 46.0788 61.3933 47.0406 61.3933H50.546C49.5824 61.3933 48.7951 60.6806 48.7951 59.8097C48.7951 58.9388 49.5824 58.2242 50.546 58.2242H48.0424C47.0788 58.2242 46.2897 57.5115 46.2897 56.6406C46.2897 55.7697 47.0788 55.0552 48.0424 55.0552H68.3093C69.273 55.0552 70.0602 55.7679 70.0602 56.6406C70.0602 57.5133 69.273 58.2242 68.3093 58.2242H70.8111C71.7747 58.2242 72.562 58.9369 72.562 59.8097C72.562 60.6824 71.7747 61.3933 70.8111 61.3933Z",
    fill: "#4211A0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M199.378 23.5327L5.1126 27.8054C2.74901 33.3016 1.18177 39.5161 0.459961 45.9559H195.975C197.247 42.1882 198.191 38.3175 198.796 34.3871C199.38 30.6035 199.613 26.9436 199.378 23.5327ZM39.9029 37.5416H36.3993C37.3629 37.5416 38.152 38.2561 38.152 39.127C38.152 39.9979 37.3629 40.7124 36.3993 40.7124H16.1324C15.1706 40.7124 14.3815 39.9979 14.3815 39.127C14.3815 38.2561 15.1706 37.5416 16.1324 37.5416H19.6378C18.6742 37.5416 17.8869 36.8288 17.8869 35.9579C17.8869 35.087 18.6742 34.3725 19.6378 34.3725H17.1342C16.1706 34.3725 15.3815 33.6598 15.3815 32.7889C15.3815 31.918 16.1706 31.2035 17.1342 31.2035H37.4011C38.3647 31.2035 39.152 31.9162 39.152 32.7889C39.152 33.6616 38.3647 34.3725 37.4011 34.3725H39.9029C40.8665 34.3725 41.6538 35.087 41.6538 35.9579C41.6538 36.8288 40.8665 37.5416 39.9029 37.5416Z",
    fill: "#4211A0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M99.1036 142.961C143.986 142.961 180.371 139.614 180.371 135.485C180.371 131.356 143.986 128.009 99.1036 128.009C54.2207 128.009 17.8359 131.356 17.8359 135.485C17.8359 139.614 54.2207 142.961 99.1036 142.961Z",
    fill: "#4211A0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M155.397 138.755C154.868 138.775 151.861 138.755 151.861 138.755C151.817 138.709 151.776 138.661 151.737 138.61C152.506 138.348 154.168 137.955 155.397 138.755Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M163.999 138.755C163.47 138.775 160.462 138.755 160.462 138.755C160.418 138.709 160.377 138.661 160.339 138.61C161.104 138.348 162.766 137.955 163.999 138.755Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3604 139.727C125.338 139.727 150.45 114.614 150.45 83.6368C150.45 52.6592 125.338 27.5469 94.3604 27.5469C63.3828 27.5469 38.2705 52.6592 38.2705 83.6368C38.2705 114.614 63.3828 139.727 94.3604 139.727Z",
    fill: "#E3DBF1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M64.9296 44.043C64.9296 44.043 48.0336 54.8446 48.1717 71.7406C48.3099 88.6367 64.9296 44.043 64.9296 44.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M195.104 133.676C197.808 133.676 200.001 133.306 200.001 132.849C200.001 132.392 197.808 132.021 195.104 132.021C192.4 132.021 190.208 132.392 190.208 132.849C190.208 133.306 192.4 133.676 195.104 133.676Z",
    fill: "#4211A0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36.9265 148.476C39.6307 148.476 41.8228 148.105 41.8228 147.649C41.8228 147.192 39.6307 146.821 36.9265 146.821C34.2224 146.821 32.0303 147.192 32.0303 147.649C32.0303 148.105 34.2224 148.476 36.9265 148.476Z",
    fill: "#4211A0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M160.294 111.157C162.998 111.157 165.19 110.787 165.19 110.33C165.19 109.873 162.998 109.503 160.294 109.503C157.59 109.503 155.397 109.873 155.397 110.33C155.397 110.787 157.59 111.157 160.294 111.157Z",
    fill: "#4211A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.388 142.95C188.426 142.95 191.699 142.397 191.699 141.714C191.699 141.031 188.426 140.478 184.388 140.478C180.35 140.478 177.077 141.031 177.077 141.714C177.077 142.397 180.35 142.95 184.388 142.95Z",
    fill: "#4211A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9592 124.148C34.9968 124.148 38.27 123.595 38.27 122.912C38.27 122.229 34.9968 121.676 30.9592 121.676C26.9216 121.676 23.6484 122.229 23.6484 122.912C23.6484 123.595 26.9216 124.148 30.9592 124.148Z",
    fill: "#4211A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8057 110.33C87.7885 106.842 95.145 101.739 104.219 110.33C101.186 108.207 93.3254 102.503 84.8057 110.33Z",
    stroke: "#4211A0",
    strokeWidth: 3.34464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3818 70.2906C62.0551 70.5936 76.218 67.5872 82.5275 56.1821M133.339 70.2906C126.665 70.5936 112.502 67.5872 106.193 56.1821",
    stroke: "#4211A0",
    strokeWidth: 1.91122,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.4068,
    cy: 74.5299,
    rx: 6.06695,
    ry: 10.3131,
    fill: "#4211A0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.319,
    cy: 74.5299,
    rx: 6.06695,
    ry: 10.3131,
    fill: "#4211A0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.11,
    cx: 69.3397,
    cy: 95.663,
    rx: 7.04675,
    ry: 7.04675,
    fill: "#4211A0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.11,
    cx: 119.386,
    cy: 95.663,
    rx: 7.04675,
    ry: 7.04675,
    fill: "#4211A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10326_157061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 147.526,
    fill: "white",
    transform: "translate(0 0.949219)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFace);
export default __webpack_public_path__ + "static/media/sad-face.5d21186f8db48b475bff609915a2b25f.svg";
export { ForwardRef as ReactComponent };